import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import {
  FlutterUKAppIcon,
  FlutterUKCustomIcon,
  FlutterUKMigIcon,
  FlutterUKMainIcon,
  FlutterUKDesignIcon,
  FlutterUKEntIcon,
} from "../../../../app-constants";
import { Link } from "gatsby";

const StackItem = [
  {
    icon: FlutterUKAppIcon,
    title: "Flutter App Consultation",
    description:
      "We realize how important it is to demonstrate your app concept before moving forward with development. That's why we provide extensive validation services to assist you in estimating market demand, defining your target audience, and fine-tuning your app concept. We as a leading Flutter development agency in UK can help you examine your Flutter app concept and guarantee that the framework is the best technical answer for your product idea.",
  },
  {
    icon: FlutterUKCustomIcon,
    title: "Custom Flutter App Development",
    description:
      "Flutter app development facilitates you to streamline your company's processes by developing complicated apps tailored to your organization's specific needs. TekRevol’s Flutter app development services are intended to help you create a cross-platform mobile experience for all of your users. Our Flutter experts and project management team create an app that suits your market and meets your business needs while also considering the customers' and operational demands, testing the functionality, and deploying it effortlessly across many platforms.",
  },
  {
    icon: FlutterUKMigIcon,
    title: "Flutter App Migration",
    description:
      "As one of the top-grade Flutter app development companies in UK, we specialize in updating your current apps to the most recent Flutter version, assuring maximum performance and security. Our Flutter engineers can help you strengthen your iOS and Android app development using Google's Flutter codebase and resources.",
  },
  {
    icon: FlutterUKMainIcon,
    title: "App Maintenance and Support",
    description:
      "Being the top-ranked Flutter app development company, we offer our clients end-to-end support and maintenance services from our Flutter experts. Our Flutter app developers are available to fix and improve your application while you continue to focus on your main business. Whether your online or mobile app needs a security update, bug fixes, or performance upgrades, our Flutter engineers can be trusted to keep your data secure.",
  },
  {
    icon: FlutterUKDesignIcon,
    title: "Flutter App Design",
    description:
      "Our design strategy prioritizes precision in order to build reliable apps quickly. We understand that a flawless user experience (UX) and an appealing user interface (UI) are essential to engaging viewers. TekRevol’s Flutter app design services excel in crafting mobile applications that boast both captivating visual appeal and exceptional functionality, ensuring a user-friendly experience. Our team of Flutter experts specializes in creating Flutter apps that are simple to manage, maintain, and expand, resulting in a wonderful user experience.",
  },
  {
    icon: FlutterUKEntIcon,
    title: "Enterprise Solutions",
    description:
      "Enterprise-level applications require strong security and powerful functionality. We, as a Flutter development agency in UK , help you to design complicated solutions for large-scale commercial businesses. When combined with the Flutter SDK, Flutter's cross-platform features and scalability allow us to create corporate apps with high security and speed. We design corporate apps using modern technologies and frameworks, guaranteeing that they are packed with advanced capabilities and features that match the changing demands of modern enterprises.",
  },
];

function Improvise(props) {
  return (
    <div className="improvise_section p-100">
      <Container className="h-100">
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={10}
            xxl={4}
            className="m-xl-auto m-xxl-0"
          >
            <h2>
              Enhance Your Brand's Digital Reach with Our Flutter App
              Development Services
            </h2>
            <p>
              We provide end-to-end Flutter app development services to help you
              create Android and iOS apps in a short time while maintaining
              quality. Our expert Flutter developers use the latest technology
              to craft solutions that drive business success. You can partner
              with us as an expert{" "}
              <Link
                to="/uk/flutter-app-development-company-london"
                rel="noopener"
                aria-label="TekRevol"
              >
                Flutter mobile app development company in UK
              </Link>
              to get a result-driven app. Here are the Flutter mobile app
              development services that we offer:
            </p>
          </Col>
          <Col xs={12} md={12} lg={12} xl={12} xxl={8}>
            <div className="stack_box">
              {StackItem.map((item, index) => (
                <div className="stack_item" key={index}>
                  <div className="stack_title">
                    {item.icon}
                    <h5>{item.title}</h5>
                  </div>
                  <p>{item.description}</p>
                </div>
              ))}
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Improvise;
